import styled from "styled-components";

export default function HomeEssentialsBanner() {
  return (
    <Wrapper href="https://www.paysfer.com/shops/aa15f57f-06f8-4f22-a0eb-47056630fefc">
      <Promo_Banner_Left>
        <Promo_Banner_Title>Home Essentials</Promo_Banner_Title>
        {/* <Promo_Banner_Content>
          Shop now for <strong>Bounty™</strong> kitchen towels,{" "}
          <strong>Tide™ </strong>Pods, and <strong>Charmin™ </strong>
          toilet papers, and <strong>Cascade™ </strong> dish detergents and
          more!
        </Promo_Banner_Content>
        <Promo_Banner_Content>
          Keep your home fresh and Save Big!
        </Promo_Banner_Content> */}
        <Promo_Fake_Button>
          <span>Shop Now!</span>
        </Promo_Fake_Button>
      </Promo_Banner_Left>
      <Promo_Banner_Right>
        <Promo_Banner_Image_Grid>
          <img
            src="https://storage.googleapis.com/content.paysfer.com/banner/bounty_removed_bg_image.png"
            alt="Bounty"
            loading="lazy"
          />
          <img
            src="https://storage.googleapis.com/content.paysfer.com/banner/charmin_removed_bg_image.png"
            alt="Charmin"
            loading="lazy"
          />
          <img
            src="https://storage.googleapis.com/content.paysfer.com/banner/tide_removed_bg_image.png"
            alt="Tide Pods"
            loading="lazy"
          />
          <img
            src="https://storage.googleapis.com/paysfer-sell-upload/65c666dfe467a043e3e0b5c8/Cascade1.png"
            alt="Cascade"
            loading="lazy"
          />
        </Promo_Banner_Image_Grid>
      </Promo_Banner_Right>
    </Wrapper>
  );
}

const Wrapper = styled.a`
  color: black;
  border: 0;
  box-shadow: none;
  border-radius: initial;
  max-width: 1800px;
  max-height: 400px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  overflow: auto;
  display: flex; /* Make the wrapper a flex container */
  @media (max-width: 1159px) {
    flex-direction: row; /* Change flex-direction back to row */
  }
`;

const Promo_Banner_Left = styled.div`
  background-color: #f7f7f7;
  color: #191919;
  width: 25%;
  padding: 24px;
  margin-bottom: 20px;
  display: flex; /* Nested flex container */
  flex-direction: column; /* Stack items vertically */
  align-items: center;
  justify-content: center;
  @media (max-width: 1159px) {
    width: 35%; /* Adjust width when viewport width is 1159px or less */
  }
  @media (max-width: 841px) {
    width: 40%; /* Adjust width when viewport width is 1159px or less */
  }
  @media (max-width: 414px) {
    width: 50%; /* Adjust width when viewport width is 1159px or less */
  }
`;

const Promo_Banner_Title = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0;
  @media (max-width: 414px) {
    font-size: 1.2rem; /* Adjust font size for smaller screens */
  }
`;

const Promo_Banner_Content = styled.div`
  font-size: 1rem;
  margin-top: 10px;
  @media (max-width: 414px) {
    font-size: 0.8rem; /* Adjust font size for smaller screens */
  }
`;

const Promo_Banner_Right = styled.div`
  background-color: #f7f7f7;
  color: #191919;
  width: 75%;
  padding: 24px;
  margin-bottom: 20px;
  display: flex; /* Nested flex container */
  flex-direction: column; /* Stack items vertically */
  @media (max-width: 1159px) {
    width: 65%; /* Adjust width when viewport width is 1159px or less */
  }
  @media (max-width: 841px) {
    width: 60%; /* Adjust width when viewport width is 1159px or less */
  }
  @media (max-width: 414px) {
    width: 50%; /* Adjust width when viewport width is 1159px or less */
    padding: 0px;
  }
`;

const Promo_Banner_Image_Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px; /* Adjust the gap between columns */
  img {
    width: 200px; /* Adjust image width */
    height: 200px; /* Adjust image height */
    object-fit: cover;
    padding: 20px;
    background-color: transparent; /* Set the background color to transparent */
  }
  @media (max-width: 1159px) {
    img:nth-child(4) {
      display: none; /* Hide the fourth image when viewport width is 1159px or less */
    }
  }
  @media (max-width: 996px) {
    img:nth-child(3) {
      display: none; /* Hide the fourth image when viewport width is 1159px or less */
    }
  }
  @media (max-width: 414px) {
    img:nth-child(2) {
      display: none; /* Hide the fourth image when viewport width is 1159px or less */
    }
  }
`;

const Promo_Fake_Button = styled.div`
  margin-top: 20px;
  padding: 8px;
  font-size: 1rem;
  border-radius: 25px;
  border: 1px solid;
  padding: 0.5rem 1rem;
  white-space: nowrap;
  max-width: 80%;
  background-color: #f7f7f7;
  cursor: pointer;
  display: flex; /* Ensure the container is a flex container */
  align-items: center; /* Align items vertically */
  justify-content: center;
  color: rgb(0, 0, 0);
  border-color: rgb(0, 0, 0);
  box-shadow: rgb(0, 0, 0) 0px 0px 0px 0px inset;
  transition: background-color 0s, color 0s; /* Instantaneous transition */
  &:hover {
    background-color: rgb(0, 49, 71);
    color: #f7f7f7;
  }
`;
